// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template4_reactPlayer__dzOpn","logo":"Template4_logo__bS2bi","heading":"Template4_heading__MaewC"};